<mf-page title="Nueva Cuenta">
  @if (miPspcId) {
  <mf-gateway-bank-account
    [miPspcId]="miPspcId"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
